<img class="icon-img" [src]="fullImgUrl">